import { render, staticRenderFns } from "./ProfileUserOrders.vue?vue&type=template&id=b557f88c&scoped=true&"
import script from "./ProfileUserOrders.vue?vue&type=script&lang=js&"
export * from "./ProfileUserOrders.vue?vue&type=script&lang=js&"
import style0 from "./ProfileUserOrders.vue?vue&type=style&index=0&id=b557f88c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b557f88c",
  null
  
)

export default component.exports